class FormAjaxHandler {
  resetAjaxMessages(messageBox) {
    messageBox.querySelectorAll(".ajax-message").forEach((el) => el.remove());
  }

  showAjaxError(messageBox, errorMsg) {
    const errorDiv = document.createElement("div");
    errorDiv.className = "ajax-message ajax-message--error";
    errorDiv.textContent = errorMsg;
    messageBox.prepend(errorDiv);
  }

  showAjaxSuccess(form, messageBox, successMsg) {
    // On success we hide all inputs
    form
      .querySelectorAll("[data-ajax-form-inputs]")
      .forEach((el) => el.classList.add("hidden"));

    const successDiv = document.createElement("div");
    successDiv.className = "ajax-message ajax-message--success";
    successDiv.innerHTML = successMsg;
    messageBox.appendChild(successDiv);
  }

  async handleAjaxResponse(response, form, messageBox) {
    const contentType = response.headers.get("content-type") || "";
    if (!response.ok) {
      let errorMsg = "Unknown error";
      if (contentType.includes("application/json")) {
        const data = await response.json();
        errorMsg = data.message || data.error || errorMsg;
      } else {
        errorMsg = await response.text();
      }
      this.showAjaxError(messageBox, errorMsg);
    } else {
      let successMsg = "";
      if (contentType.includes("application/json")) {
        const data = await response.json();
        successMsg = data.message || "Success";
      } else {
        successMsg = await response.text();
      }
      this.showAjaxSuccess(form, messageBox, successMsg);
    }
  }

  async submitAjaxForm(e) {
    e.preventDefault();
    const form = e.target;
    const url = form.action;
    const method = form.method || "POST";
    const formData = new FormData(form);
    const messageBox = form.querySelector("[data-ajax-form-message]") || form;
    this.resetAjaxMessages(messageBox);
    try {
      const response = await fetch(url, {
        method,
        body: formData,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      await this.handleAjaxResponse(response, form, messageBox);
    } catch (err) {
      this.showAjaxError(messageBox, err.message || "Network error");
    }
  }

  bindAjaxForms() {
    document.querySelectorAll("form[data-ajax-form]").forEach((form) => {
      form.addEventListener("submit", this.submitAjaxForm.bind(this));
    });
  }

  static init() {
    const handler = new FormAjaxHandler();
    handler.bindAjaxForms();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  FormAjaxHandler.init();
});
